// Principal Value
// Copyright (c) 2012 Sutoiku, Inc. (MIT License)

export const PV = (rate, periods, payment, future = 0, type = 0) => {

  // Return present value
  if (rate === 0) {
    return - payment * periods - future;
  } else {
    return (((1 - Math.pow(1 + rate, periods)) / rate) * payment * (1 +rate * type) - future) / Math.pow(1 + rate, periods);
  }
}


// Future Value
export const FV = (rate, periods, payment, value, type) => {
    // Credits: algorithm inspired by Apache OpenOffice
  
    value = value || 0;
    type = type || 0;
  
    rate = Number(rate);
    periods = parseInt(periods);
    payment = Number(payment);
    value = Number(value);
    type = Number(type);
  
    // Return future value
    var result;
    if (rate === 0) {
      result = value + payment * periods;
    } else {
      var term = Math.pow(1 + rate, periods);
      if (type === 1) {
        result = value * term + payment * (1 + rate) * (term - 1) / rate;
      } else {
        result = value * term + payment * (term - 1) / rate;
      }
    }
    return -result;
  }


// Periodical Monthly Payment
export const PMT = (interestRate, months, presentValue, futureValue = 0, type = 0) => {
    /*
     * interestRate   - interest rate per month
     * months  - number of periods (months)
     * presentValue   - present value
     * fv   - future value
     * type - when the payments are due:
     *        0: end of the period, e.g. end of month (default)
     *        1: beginning of period
     */
    let monthlyRepayment, interestFactor;

    if (interestRate === 0) return -(presentValue + futureValue)/months;

    interestFactor = Math.pow(1 + interestRate, months);
    monthlyRepayment = - interestRate * (presentValue * interestFactor + futureValue) / (interestFactor - 1);

    if (type === 1) monthlyRepayment /= (1 + interestRate);

    return monthlyRepayment;
}


// Cumulative Periodical Monthly Payment
export const CUMIPMT = (rate, periods, value, start = 1, end, type = 0) => {
    // Credits: algorithm inspired by Apache OpenOffice
    // Credits: Hannes Stiebitzhofer for the translations of function and variable names
    // Requires exports.FV() and exports.PMT() from exports.js [http://stoic.com/exports/]
  
    rate = Number(rate);
    periods = parseInt(periods);
    value = Number(value);
    end = end ? end : periods

    // Return error if either rate, periods, or value are lower than or equal to zero
    // if (rate <= 0 || periods <= 0 ) return 0

    // Return error if start < 1, end < 1, or start > end
    if (start < 1 || end < 1 || start > end) return 0;

    // Return error if type is neither 0 nor 1
    if (type !== 0 && type !== 1) return 0;
  
    // Compute cumulative interest
    var payment = PMT(rate, periods, value, 0, type);
    var interest = 0;
  
    if (start === 1) {
      if (type === 0) {
        interest = -value;
        start++;
      }
    }
  
    for (var i = start; i <= end; i++) {
      if (type === 1) {
        interest += FV(rate, i - 2, payment, value, 1) - payment;
      } else {
        interest += FV(rate, i - 1, payment, value, 0);
      }
    }
    interest *= rate;
  
    // Return cumulative interest
    return interest;
  };
  

  // Cumulative Principal
  export const CUMPRINC = (rate, periods, value, start = 0, end = 0, type = 0) => {
    // Credits: algorithm inspired by Apache OpenOffice
    // Credits: Hannes Stiebitzhofer for the translations of function and variable names
  
    rate = Number(rate);
    periods = parseInt(periods);
    value = Number(value);

  
    // Return error if either rate, periods, or value are lower than or equal to zero
    if (rate <= 0 || periods <= 0 || value <= 0) return 0;
  
    // Return error if start < 1, end < 1, or start > end
    if (start < 1 || end < 1 || start > end) return 0;
  
    // Return error if type is neither 0 nor 1
    if (type !== 0 && type !== 1) return 0;
  
    // Compute cumulative principal
    var payment = PMT(rate, periods, value, 0, type);
    var principal = 0;
    if (start === 1) {
      if (type === 0) {
        principal = payment + value * rate;
      } else {
        principal = payment;
      }
      start++;
    }
    for (var i = start; i <= end; i++) {
      if (type > 0) {
        principal += payment - (exports.FV(rate, i - 2, payment, value, 1) - payment) * rate;
      } else {
        principal += payment - exports.FV(rate, i - 1, payment, value, 0) * rate;
      }
    }
  
    // Return cumulative principal
    return principal;
  };

